<script setup>
  import { nextTick, onMounted, ref } from 'vue'
  import { useEventsStore } from '@/stores/events'
  import EventGroupRow from '@/components/Event/GroupRow.vue'

  const props = defineProps({
    items: String
  })

  onMounted(async () => {
    const store = await useEventsStore()

    const data = await store.fetchEvents(props.items)

    await createGroupItems(data.items)
  })

  const groupItems = ref([])
  // Create Groups of four Items
  const createGroupItems = (items) => {
    const groups = []
    for (let i = 0; i < items.length; i += 4) {
      groups.push(items.slice(i, i + 4))
    }
    groupItems.value = groups
  }

  const updateGroup = (index) => {
    nextTick(() => {
    })
  }

</script>

<template>
  <div
    v-if="groupItems"
    class="course-events-mobile-wrapper"
  >
    <EventGroupRow
      v-for="(group, index) in groupItems"
      :key="index"
      :items="group"
      @updateGroup="updateGroup"
    />
  </div>
</template>


<style lang="scss" scoped>

</style>
